export default "__VITE_ASSET__c3b56b72__"